import React, { useEffect } from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import { usePageMeta } from "@/lib/usePageMeta";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import FeaturePillars from "@/components/landing/FeaturePillars";
import PersonasTabs from "@/components/landing/PersonasTabs";
import SupportedPlatforms from "@/components/landing/SupportedPlatforms";
import HowItWorks from "@/components/landing/HowItWorks";
import FinalCTA from "@/components/landing/FinalCTA";

export default function Landing() {
  usePageMeta(
    "Leadmato — Find real customers across social platforms",
    "Type a query. Get real customers. Leadmato scans Reddit, X, LinkedIn and forums on-demand and ranks buyer-intent signals for Indian SMBs.",
  );

  useEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "smooth";
    return () => { html.style.scrollBehavior = prev; };
  }, []);

  return (
    <MarketingLayout>
      <Hero />
      <SupportedPlatforms />
      <FeaturePillars />
      <PersonasTabs />
      <TrustBar />
      <HowItWorks />
      <FinalCTA />
    </MarketingLayout>
  );
}
